import { apiClient } from "../config";

async function getReportNotifications(queryParams: any) {
  const res = await apiClient.get(
    `/admin/dashboard/widget/report-notifications`,
    {
      params: queryParams,
    }
  );
  return res.data;
}

export default getReportNotifications;
